import { Select, Table, TableColumnsType } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { deleteOceanStudent, getIrregularOceanStudents } from "../../../api/oceanManagement.api";
import { getOceanResultUrl, getPredigerHistoryCode } from '../../../api/oceanTest.api';
import useAuth from "../../../hooks/useAuth";
import useAxios from "../../../hooks/useAxios";
import useNotification from "../../../hooks/useNotification";
import config from "../../../lib/config";
import { IGetIrregularOceanStudents, IIrregularOceanStudent } from "../../../models/oceanManagement.model";
import { IGetOceanUrl } from "../../../models/oceanTest.model";
import { RootState } from "../../../store/rootReducer";
import Button from "../../Button";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";
import Pagination from "../../Pagination";
import AddStudentModal from "./modals/AddStudentModal";
import { useTranslation } from "react-i18next";

const Irregular = () => {
  const { t } = useTranslation();
  const { writeAuthYn } = useAuth();
  const { auth } = useSelector((state: RootState) => state.auth);
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetIrregularOceanStudents>();
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<IGetOceanUrl>();
  const { data: deleteRes, isLoading: deleteIsLoading, error: deleteError, execute: deleteExecute } = useAxios();

  const [data, setData] = useState<IIrregularOceanStudent[]>([]);
  const [eduStepCode, setEduStepCode] = useState('');
  const [pageNo, setPageNo] = useState(1);
  const [addStudentVisible, setAddStudentVisible] = useState(false);

  useEffect(() => {
    doGetIrregularOceanStudents();
  }, []);

  useEffect(() => {
    if (res) {
      setData(res.data);
    }
  }, [res]);

  useEffect(() => {
    if (res2 && !isLoading2) {
      window.open(`${res2?.data}&employeeMemberCode=${auth.memberCode}`, '_blank', 'width=1200, height=768, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no');
    }
  }, [res2, isLoading2]);

  useEffect(() => {
    if (deleteRes && !deleteIsLoading) {
      doGetIrregularOceanStudents();
      successNotification(t('common.message.delete'));
    }
  }, [deleteRes, deleteIsLoading]);

  const doGetIrregularOceanStudents = () => {
    execute(getIrregularOceanStudents());
  };

  const onSetEduStepCode = (value: string) => {
    setEduStepCode(value);
    if (value) {
      const filtered = res?.data.filter(item => item.eduStepCode === value);
      setData(filtered || []);
    } else {
      setData(res?.data || []);
    }
  };

  const onDeleteStudent = (testNo: number) => {
    deleteExecute(deleteOceanStudent(testNo));
  };

  const onOpenOceanResultPopup = (oceanTestCode: number) => {
    execute2(getOceanResultUrl(oceanTestCode));
  }

  const columns: TableColumnsType<IIrregularOceanStudent> = [
    {
      title: t('class.class.9'),
      dataIndex: 'eduStepCode',
      align: 'center',
      render: value => value === 'EM' ? 'OCEAN' : 'Prediger',
    },
    {
      title: t('class.class.21'),
      dataIndex: 'memKorName',
      key: 'memKorName',
      align: 'center',
    },
    {
      title: t('class.class.22'),
      dataIndex: 'testCompleteDateTime',
      key: 'testCompleteDateTime',
      align: 'center',
      render: value => value ? moment(value).format('YYYY.MM.DD HH:mm:ss') : '-',
    },
    {
      title: t('common.button.delete'),
      key: 'testNo',
      dataIndex: 'testNo',
      align: 'center',
      render: (value, record) => (
        <div className="comm-btn__area justify-content-center">
          <Button
            onClick={() => onDeleteStudent(value)}
            className="btn-basic gray"
            text={t('common.button.delete')}
            disabled={record.oceanResult !== 'N'}
            writeAuthYn={writeAuthYn}
          />
        </div>
      ),
    },
    {
      title: t('class.class.23'),
      key: 'oceanResult',
      dataIndex: 'oceanResult',
      align: 'center',
      render: (value, record) => value === 'Y'
        ? (
          <div className="comm-btn__area justify-content-center">
            <Button
              onClick={() => onOpenOceanResultPopup(record.testNo)}
              className="btn-basic pink-line"
              text={t('class.class.24')}
              writeAuthYn={writeAuthYn}
            />
          </div>
          )
        : value
    },
  ];

  return (
    <>
      {(isLoading || isLoading2 || deleteIsLoading) && <Loader />}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />
      <ErrorResponse error={deleteError} />

      <div className="comm-bx__between">
        <div>
          <Select
            className="w-150p"
            value={eduStepCode}
            onChange={value => onSetEduStepCode(value)}
          >
            <Select.Option value="">{t('common.text.all')}</Select.Option>
            <Select.Option value="EM">OCEAN</Select.Option>
            <Select.Option value="MD">Prediger</Select.Option>
          </Select>
        </div>
        <div className="comm-btn__area">
          <Button
            onClick={() => setAddStudentVisible(true)}
            className="btn-basic pink-line"
            text={t('class.class.25')}
            writeAuthYn={writeAuthYn}
          />
        </div>
      </div>

      <div className='comm-table__area'>
        <Table
          columns={columns}
          dataSource={data}
          pagination={{
            current: pageNo,
            pageSize: config.pageSize,
          }}
        />
      </div>

      <div className="comm-bx__between">
        <div className="common-paging center">
          <Pagination
            count={data.length}
            page={pageNo}
            setPage={setPageNo}
          />
        </div>
      </div>

      {addStudentVisible &&
        <AddStudentModal
          visible={addStudentVisible}
          setVisible={setAddStudentVisible}
          campusCode={currentCampus}
          doGetOceanStudents={doGetIrregularOceanStudents}
        />
      }
    </>
  );
}

export default Irregular;
